// extracted by mini-css-extract-plugin
export default {"price":"i7-z","priceRow":"j7-z","onSale":"k7-z","msrpLabelPrice":"l7-z","msrpLabel":"m7-z","originalPrice":"n7-z","percentOff":"o7-z"};